import { GetStaticPropsContext } from "next";
import ErrorPage from "next/error";
import Head from "next/head";
import ContentNotFound from "../../components/ContentNotFound";
import Layout from "../../components/layout";
import CelebrityCard from "../../components/Layout/CelebrityCard";
import SEOMeta from "../../components/SEOMeta";
import {
  getLatestBlogs,
  getPopularBlogs,
  getProfessions,
  getProfessionsBySlug,
  resolveAll,
} from "../../lib/api";

function slug({ profData }) {
  if (!profData) return <ErrorPage statusCode={404} />;
  const celeb = profData[0].node.celebrity;
  if (!celeb) return <ErrorPage statusCode={404} />;

  return (
    <Layout>
      <Head>
        <title>{profData[0].node.seo.title}</title>
        <SEOMeta seoData={profData[0].node.seo} type="profession" />
      </Head>

      <main className="blog-page-main-sec trending-post-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <header className="blog-page-dsc mb-4">
                <h2 className=" page-title text-center mt-3">
                  {" "}
                  <span style={{ fontWeight: "bold" }}>Profession:</span>{" "}
                  {profData[0].node.name}{" "}
                </h2>
              </header>
            </div>

            <div className="col-lg-12">
              <div className="celebrity-sec-card-whapper mb-5 post-grid-wrapper">
                {celeb.edges &&
                  celeb.edges.map(({ node, index }) => (
                    <CelebrityCard key={index} data={node}/>
                  ))}
                {celeb.edges.length <= 0 && <ContentNotFound />}
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default slug;

export async function getStaticProps({
  params,
  preview = false,
}: GetStaticPropsContext) {
  const limit = 5;
  const [data, sidebarLatestPosts, sidebarPopularPosts] = await resolveAll([
    getProfessionsBySlug(params.slug as string[], preview),
    getLatestBlogs(limit, preview),
    getPopularBlogs(limit, preview),
  ]);

  return {
    props: {
      preview,
      profData: data?.edges ?? "",
      sidebarLatestPosts,
      sidebarPopularPosts,
    },
    revalidate: 60 * 60 * 24,
  };
}

export async function getStaticPaths(preview) {
  const allProf = await getProfessions(preview);

  return {
    paths: allProf.edges.map(({ node }) => `/profession/${node.slug}`) || [],
    fallback: true,
  };
}
